<template>
  <div class="selected-package-list">
    <div class="header">
      <h4 class="count">{{ selectedPackageLabel }} {{ count }} แพ็กเกจ</h4>
      <sc-button
        v-if="showRemoveAllButton"
        :disabled="disabledRemoveButton"
        class="remove-all-button"
        @click="handleClickRemoveAllButton"
      >ลบทั้งหมด</sc-button>
    </div>
    <div class="list-body">
      <div v-if="isEmpty" class="empty">ไม่มีแพ็กเกจที่เลือก</div>
      <draggable
        v-model="sorted"
        v-bind="dragOptions"
        class="list"
        @start="drag = true"
        @end="drag = false"
      >
        <transition-group :name="!drag ? 'flip-list' : null" type="transition">
          <package-selector-option
            v-for="item in sorted"
            :key="item.id"
            v-bind="item"
            :can-remove="canRemove"
            class="selected-item"
            @remove="handleRemove(item)"
          ></package-selector-option>
        </transition-group>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ScButton from "@/lib/components/ScButton";
import PackageSelectorOption from "./PackageSelectorOption";

export default {
  components: {
    PackageSelectorOption,
    ScButton,
    draggable
  },
  props: {
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    selectedPackageLabel: { type: String, default: "" },
    isActionEdit: { type: Boolean, default: false }
  },
  data() {
    return {
      drag: false
    };
  },
  computed: {
    sorted: {
      get() {
        return this.value;
      },
      set(value) {
        return this.$emit("input", value);
      }
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    isEmpty() {
      return this.value.length === 0;
    },
    count() {
      return this.value.length;
    },
    disabledRemoveButton() {
      return this.isEmpty || !this.canRemove || this.isActionEdit;
    },
    canRemove() {
      return !this.disabled;
    },
    showRemoveAllButton() {
      return this.canRemove;
    }
  },
  methods: {
    handleRemove(item) {
      this.$emit("remove", item);
    },
    handleClickRemoveAllButton() {
      this.$emit("removeAll");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.selected-package-list {
  border: $border;
  border-radius: $border-radius;
}

.header {
  display: grid;
  grid-template-columns: 1fr auto;

  border-bottom: $border;

  > .remove-all-button {
    height: 42px;
    font-size: 0.8rem;
    color: #444;
    border: 0;
    border-radius: 0;
    border-top-right-radius: $border-radius;
    border-left: $border;

    &:hover,
    &:focus {
      border-color: #dcdfe6 !important;
    }
  }
}

.selected-package-list > .list-body {
  overflow-y: auto;
  height: 500px;
}

.empty {
  padding: 20px 0;
  text-align: center;
}

.count {
  margin: 0;
  padding: 10px ($space / 2);

  color: $primary-color;
  font-size: 1.1rem;
  font-weight: bold;
}
</style>
